import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FilePreviewComponent } from './FilePreview.component';

@NgModule({
  imports: [
    // Minga dependencies

    // External dependencies
    CommonModule,
  ],
  declarations: [FilePreviewComponent],
  exports: [FilePreviewComponent],
})
export class FilePreviewModule {}
